var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 6.165c0-.483.169-.88.507-1.194.338-.314.777-.471 1.317-.471.531 0 .96.154 1.289.463.338.319.507.734.507 1.245 0 .464-.164.85-.493 1.159-.337.318-.781.478-1.332.478h-.014c-.531 0-.96-.16-1.289-.478-.328-.319-.492-.72-.492-1.202zm.188 12.669V9.162h3.215v9.672H4.688zm4.995 0h3.215v-5.4c0-.338.038-.6.116-.782a2.1 2.1 0 01.615-.833c.275-.227.62-.34 1.035-.34 1.081 0 1.622.729 1.622 2.186v5.169H19.5v-5.545c0-1.429-.338-2.512-1.014-3.25-.675-.74-1.568-1.108-2.678-1.108-1.245 0-2.215.535-2.91 1.607v.029h-.015l.015-.03V9.163H9.683c.02.309.03 1.27.03 2.881 0 1.612-.01 3.876-.03 6.791z","fillRule":"evenodd"}));
}

Linkedin.defaultProps = {"width":"24","height":"24"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
